import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
    transform(value: string | Date | undefined | null, format: string = 'DD/MM/YYYY HH:mm'): string {
        if (!value) {
            return '-'; // Valor padrão para datas ausentes
        }

        // Interpreta a data como UTC e converte para o horário local
        return moment.utc(value).local().format(format);
    }
}
